import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.cancelQuestionnaire.loading;
export const questionnariesErrorMessage = (state: RootState) =>
  state.cancelQuestionnaire.error;
export const cancelQuestionnaireDataResponse = (state: RootState) =>
  state.cancelQuestionnaire.cancelQuestionnaireResponse;
